import React, { Component } from "react";
import { Link } from 'react-router-dom';
import GravityForm from "react-gravity-form";

export default class PageFooter extends Component {
	
	render () {
		
		let post = this.props.post;
		
		if (post) {
				   
		    return (
			    
				<div className="c-footer c-page__block--load-effect">
			    	<div className="c-footer__inner">
			    		<h2 className="c-footer__heading"><Link to={{ pathname: '/contact/' }} dangerouslySetInnerHTML={{__html:'Contact Us'}}></Link></h2>
			    		{post.ftr_address &&
			    			<div className="c-footer__text scope-footer-text" dangerouslySetInnerHTML={{__html:post.ftr_address}}></div>
			    		}
			    		<ul className="c-footer__social">
			    			{post.ftr_instagram_url &&
				    			<li className="c-footer__social__item">
				    				<a href={post.ftr_instagram_url} target="_blank" className="c-footer__social__link" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 30 30"><path style="fill:#3A3A3D;" d="M15,0C6.73,0,0,6.73,0,15s6.73,15,15,15s15-6.73,15-15S23.27,0,15,0z M15,29.37 C7.08,29.37,0.63,22.92,0.63,15C0.63,7.08,7.08,0.63,15,0.63c7.92,0,14.37,6.45,14.37,14.37C29.37,22.92,22.92,29.37,15,29.37z M15,10.47c-2.5,0-4.53,2.03-4.53,4.53s2.03,4.53,4.53,4.53s4.53-2.03,4.53-4.53C19.53,12.5,17.5,10.47,15,10.47z M15,17.94 c-1.62,0-2.94-1.32-2.94-2.94c0-1.63,1.32-2.94,2.94-2.94s2.94,1.32,2.94,2.94C17.94,16.62,16.62,17.94,15,17.94z M19.71,9.23 c-0.59,0-1.06,0.47-1.06,1.06c0,0.59,0.47,1.06,1.06,1.06c0.59,0,1.06-0.48,1.06-1.06C20.77,9.7,20.3,9.23,19.71,9.23z M18.64,6.23 C17.7,6.18,17.4,6.17,15,6.17c-2.4,0-2.7,0.01-3.64,0.05c-3.21,0.15-4.99,1.93-5.14,5.13C6.18,12.3,6.17,12.6,6.17,15 c0,2.4,0.01,2.7,0.05,3.64c0.15,3.21,1.93,4.99,5.14,5.13c0.94,0.04,1.24,0.05,3.64,0.05c2.4,0,2.7-0.01,3.64-0.05 c3.2-0.15,4.99-1.92,5.13-5.13c0.04-0.94,0.05-1.24,0.05-3.64c0-2.4-0.01-2.7-0.05-3.64C23.63,8.16,21.85,6.37,18.64,6.23z M22.19,18.57c-0.11,2.37-1.22,3.51-3.62,3.62c-0.93,0.04-1.21,0.05-3.57,0.05c-2.36,0-2.64-0.01-3.57-0.05 c-2.4-0.11-3.51-1.25-3.62-3.62C7.77,17.63,7.76,17.36,7.76,15c0-2.36,0.01-2.64,0.05-3.57c0.11-2.38,1.22-3.51,3.62-3.62 c0.93-0.04,1.21-0.05,3.57-0.05c2.36,0,2.64,0.01,3.57,0.05c2.39,0.11,3.51,1.24,3.62,3.62c0.04,0.93,0.05,1.21,0.05,3.57 C22.24,17.36,22.23,17.64,22.19,18.57z"/></svg>'}}></a>
				    			</li>
			    			}
			    			{post.ftr_linkedin_url &&
				    			<li className="c-footer__social__item">
				    				<a href={post.ftr_linkedin_url} target="_blank" className="c-footer__social__link" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 30 30"><path style="fill:#3A3A3D;" d="M15,0C6.7,0,0,6.7,0,15s6.7,15,15,15c8.3,0,15-6.7,15-15S23.3,0,15,0z M15,29.4 C7.1,29.4,0.6,22.9,0.6,15C0.6,7.1,7.1,0.6,15,0.6c7.9,0,14.4,6.4,14.4,14.4C29.4,22.9,22.9,29.4,15,29.4z M9,6.7 c-1,0-1.8,0.8-1.8,1.8c0,1,0.8,1.8,1.8,1.8c1,0,1.8-0.8,1.8-1.8C10.8,7.5,9.9,6.7,9,6.7z M7.4,23h3.1V11.6H7.4V23z M15.6,13.5v-1.8 h-3.1V23h3.1v-5.8c0-3.2,4.1-3.5,4.1,0V23h3.1v-7C22.9,10.6,17.1,10.8,15.6,13.5z"/></svg>'}}></a>
				    			</li>
			    			}
			    			{post.ftr_youtube_url &&
				    			<li className="c-footer__social__item">
				    				<a href={post.ftr_youtube_url} target="_blank" className="c-footer__social__link" dangerouslySetInnerHTML={{__html:'<svg x="0px" y="0px" viewBox="0 0 30 30"><path style="fill:#3A3A3D;" d="M20.6,9.14c-2.65-0.18-8.55-0.18-11.2,0c-2.87,0.2-3.2,1.59-3.23,6.17c0.02,4.57,0.36,5.97,3.23,6.17 c2.65,0.18,8.55,0.18,11.2,0c2.87-0.2,3.2-1.59,3.23-6.17C23.8,10.74,23.47,9.33,20.6,9.14z M12.48,18.26v-5.91l6.2,2.95 L12.48,18.26z M15,0C6.73,0,0,6.73,0,15s6.73,15,15,15c8.27,0,15-6.73,15-15S23.27,0,15,0z M15,29.37C7.08,29.37,0.63,22.92,0.63,15 C0.63,7.08,7.08,0.63,15,0.63c7.92,0,14.37,6.45,14.37,14.37C29.37,22.92,22.92,29.37,15,29.37z"/></svg>'}}></a>
				    			</li>
			    			}
			    		</ul>
			    		<ul className="c-footer__links">
			    			{post.ftr_disclaimer_url &&
				    			<li className="c-footer__links__item">
				    				<Link to={{ pathname:post.ftr_disclaimer_url}} className="c-footer__links__link" dangerouslySetInnerHTML={{__html:'Disclaimer'}}></Link>
				    			</li>
			    			}
			    			{post.ftr_privacy_url &&
				    			<li className="c-footer__links__item">
				    				<Link to={{ pathname:post.ftr_privacy_url}} className="c-footer__links__link" dangerouslySetInnerHTML={{__html:'Privacy Policy'}}></Link>
				    			</li>
			    			}
			    		</ul>
			    	</div>
				
				</div>
			)
			
		} else {
			
			return false;
			
		}
		
	}
			
}
